// extracted by mini-css-extract-plugin
export default {"day":"styles_day__8usIQ","active":"styles_active__HI7f7","highlight":"styles_highlight__KfZ05","empty":"styles_empty__yYXUN"};